<template>
  <div>
    <section class="login-container boxed-login" @keyup.enter="signin">
      <div class="container">
        <div class="col-md-4 col-md-offset-4 col-sm-4 col-sm-offset-4">
          <div class="login-form-container">
            <div class="j-forms" id="forms-login" novalidate="novalidate">
              <div class="login-form-header">
                <div class="logo">
                  <img class="logo-pic" src="../../assets/img/logo3.png" alt="logo">
                </div>
              </div>
              <h3>密碼重設</h3>
              <div class="login-form-content">
                <!-- start login -->
                <div class="unit">
                  <div class="input login-input">
                    <label class="icon-left" for="login">
                      <i class="zmdi zmdi-account"></i>
                    </label>
                    <input class="form-control login-frm-input" type="text" readonly id="login" name="email" placeholder="Email" v-model="email" v-validate="'required|email'">
                    <i v-show="errors.has('email')" class="fa fa-warning"></i>
                    <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
                  </div>
                </div>
                <!-- end login -->
                <!-- start password -->
                <div class="unit">
                  <div class="input login-input">
                    <label class="icon-left" for="password">
                      <i class="zmdi zmdi-key"></i>
                    </label>
                    <input class="form-control login-frm-input" type="password" id="password" name="password" placeholder="新密碼" v-model="password">
                  </div>
                </div>
                <!-- end password -->
                <!-- start password -->
                <div class="unit">
                  <div class="input login-input">
                    <label class="icon-left" for="password">
                      <i class="zmdi zmdi-key"></i>
                    </label>
                    <input class="form-control login-frm-input" type="password" id="re_password" name="re_password" placeholder="請再次輸入新密碼" v-model="re_password">
                  </div>
                </div>
                <!-- end password -->
                <!-- start response from server -->
                <div class="response">{{response}}</div>
                <!-- end response from server -->
              </div>
              <div class="login-form-footer" style="padding-top:0px;">
                <button class="btn-block btn btn-info" v-on:click="reset_validate">送出重設</button>
              </div>
            </div>
            <hr>
            <div class="pointer">
                <a class="gary" @click="goToLogin()">返回登入頁</a>
            </div>
          </div>
        </div>
      </div>
      <!--Footer Start Here -->
      <footer class="login-page-footer">
      </footer>
      <!--Footer End Here -->
    </section>
    
    <!-- modal template end-->
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'

export default {
  name: 'reset_password',
  components: { Simplert },
  data() {
    return {
      email: '',
      resend_email: '',
      response: '',
      resendValidateMailModal: false,
      forgotPasswordModal: false,
      email: '',
      reset_token: '',
      password: '',
      re_password: '',
      refs: this.$refs
    }
  },
  beforeCreate: function() {
    document.body.className = 'reset_password';
  },
  created() {
    this.checkLogin();
    this.checkParams();
  },
  methods: {
    checkParams(){
      this.email = this.$route.query.email
      this.reset_token = this.$route.query.reset_token
      console.log(this.email !=''&& this.reset_token!='')
      if(this.email ===undefined || this.reset_token === undefined){
        this.$router.push('/login');
      }

      const vm = this;
      this.axios.post('sessions/check_reset_link', {
        user: {
          email: this.email,
          reset_token: this.reset_token,
        }
      })
      .then(function(response) {
        if (response['data']['status'] == 'success') {

        } else if (response['data']['status'] == 'fail') {
          var obj = {
            isShown: true,
            title: '此連結已失效',
            message: '請重新點擊密碼重設，並盡快點到信箱檢查與重設。若有遇到需要協助的問題，請與Flowneat聯繫：02-2711-1223',
            type: 'error',
            customCloseBtnText: '返回',
            onClose: vm.goToLogin,
            disableOverlayClick: true
          }
          vm.refs.simplert.openSimplert(obj);
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });

    },
    reset_validate() {
      if (this.password != this.re_password) {
        this.response = "*兩次密碼不相符合，請重新輸入"
      }else{
        this.response = ""
      }

      if(this.password ==""  || this.re_password == "") {
        this.response = "*請填寫密碼"
      }

      if(this.response == ""){
        this.submitResetForm()
      }
    },
    submitResetForm() {
      const vm = this;
      this.axios.post('sessions/reset_password', {
        user: {
          email: this.email,
          password: this.password,
          re_password: this.re_password,
          reset_token: this.reset_token,
        }
      })
      .then(function(response) {
        if (response['data']['status'] == 'success') {
          var obj = {
            isShown: true,
            title: '重設成功',
            message: '已經重新設定完成密碼，您可以現在前往登入囉',
            type: 'success',
            customCloseBtnText: '前往登入',
            onClose: vm.goToLogin,
            disableOverlayClick: true,
          }
          vm.refs.simplert.openSimplert(obj);
        } else if (response['data']['status'] == 'fail') {
          var obj = {
            isShown: true,
            title: '重設失敗',
            message: response['data']['msg'],
            type: 'error',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj);
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    // if user have already login, then deny him go login page
    checkLogin() {
      if (getCookie('auth_token')) {
        this.$router.push('/dashboard');
      }
    },
    goToLogin(){
      this.$router.push('/login');
    }
  }
}
</script>


// WEBPACK FOOTER //
// ResetPassword.vue?5db05ab8